import { Icon } from '@iconify/react'

import { CompanyLogo, Tooltip } from '@pepper/ui'
import { truncateURL } from 'container/SEOTools/ContentGapReport/utils'

import s from './CompetitorLogo.module.css'

type Props = {
  competitor: {
    url: string
    length?: number
  }
  className?: string
}

export const CompetitorLogo = ({ competitor, className }: Props) => {
  const { origin } = new URL(competitor.url)

  const tooltip = (
    <>
      <div className={s.link}>
        <a
          className={s.url}
          href={competitor.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {truncateURL(competitor.url)}
        </a>
        <Icon icon="lucide:external-link" />
      </div>
      {competitor.length !== undefined && (
        <div className={s.words}>{competitor.length} words</div>
      )}
    </>
  )

  return (
    <Tooltip className={className} title={tooltip}>
      <CompanyLogo
        companyName={origin}
        className={s.avatar}
        fallbackClassName={s.fallback}
      />
      &nbsp;
    </Tooltip>
  )
}
